import type { Components } from '@mui/material/styles';

export default function MUIMobileStepper(): Components['MuiMobileStepper'] {
  return {};
}
